import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IDashboardService } from "services/DashboardService";
import { CaseModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  ActionableCases: new Array<CaseModel>(),
  LoadingActionableCases: false,
};

export const ActionableCasesSlice = createSlice({
  name: "actionableCases",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getActionableCases.pending, (state) => {
        state.LoadingActionableCases = true;
      })
      .addCase(getActionableCases.fulfilled, (state, action) => {
        state.ActionableCases = action.payload;
        state.LoadingActionableCases = false;
      })
      .addCase(getActionableCases.rejected, (state) => {
        state.LoadingActionableCases = false;
      });
  },
});

export const getActionableCases = createAsyncThunk("actionableCases/GetActionableCases", async () => {
  const dashboardService = container.get<IDashboardService>(SERVICE_TYPES.DashboardService);
  return await dashboardService.getActionableCases();
});

export const selectActionableCases = (state: RootState) => {
  return state.actionableCases.ActionableCases;
};

export const selectLoadingActionableCases = (state: RootState) => {
  return state.actionableCases.LoadingActionableCases;
};

export default ActionableCasesSlice.reducer;
